import { Component } from 'react';

/** يعرض أي خطأ في مكانه بدل تفريغ الصفحة */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">⚠️</div>
          <h1>حدث خطأ غير متوقع</h1>
          <p className="error">{String(this.state.error?.message || this.state.error)}</p>
          <pre className="stack">{this.state.error?.stack}</pre>
          <button className="btn btn-primary full" onClick={() => location.reload()}>
            إعادة تحميل الصفحة
          </button>
        </div>
      </div>
    );
  }
}